/* file description */
import { UseGetTreeData } from './type';
import { useEffect, useState, useRef } from 'react';
import { COLUMN_FROM } from '../../../effects/consts';
import { getUserByRole } from '@/common/asset-apis/assetModel';

export const useGetTreeData: UseGetTreeData = ({ field, FetchAPI, form, config, columnFrom, onChange, moduleInfo }) => {
  const { dispatchEvent, destroyEvent } = config.metaStore || {};
  const [parentValue, setparentValue] = useState('');
  const [treeData, setTreeData] = useState<any[]>([]);
  const firstUpdate = useRef(true);

  // let parentValue: string | undefined;
  // if (columnFrom === COLUMN_FROM.TABLE) {
  //   if (form.getFieldsValue()[config.rowIndex]) {
  //     parentValue = form.getFieldsValue()[config.rowIndex][field?.bizConfig?.parentField];
  //   }
  // } else {
  //   parentValue = form.getFieldsValue()[field?.bizConfig?.parentField];
  // }
  useEffect(() => {
    if (field?.bizConfig?.parentField) {
      let pvalue: string | undefined;
      if (columnFrom === COLUMN_FROM.TABLE) {
        if (config.formValue[config.rowIndex]) {
          pvalue = config.formValue[config.rowIndex][field?.bizConfig?.parentField];
        }
      } else {
        pvalue = config.formValue[field?.bizConfig?.parentField];
      }
      setparentValue(pvalue);
      const events = [{
        code: field.name,
        name: field.label,
        touchConfig: 'change',
        actionType: 'callback',
        moduleName: moduleInfo.handle,
        fieldName: field?.bizConfig?.parentField,
        rowIndex: config.rowIndex,
        fun: (value: any) => {
          setparentValue(value);
        },
      }];
      const ids = dispatchEvent?.(events);
      return () => {
        destroyEvent?.(ids);
      };
    }
  }, []);

  useEffect(() => {
    if (firstUpdate.current) {
      // 初始化时可能会加载多次，导致清空值。后续全局优化
      setTimeout(() => {
        firstUpdate.current = false;
      }, 1000);
    } else {
      onChange && onChange(null);
    }
    if (parentValue || field?.bizConfig?.filterField) {
      const roleId = field?.bizConfig?.filterField || parentValue;
      getUserByRole(FetchAPI, { roleId }).then((res) => {
        setTreeData(res);
      });
    } else {
      setTreeData(field?.bizConfig?.userList || []);
    }
  }, [parentValue]);

  return {
    treeData,
  };
};
